import React from 'react';
import { translate } from 'core/utils';
import { BaasicInput, BaasicDropdown, BaasicButton, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import { observer } from 'mobx-react';

const MarkAsShippedTemplate = ({
	t,
	markAsShippedViewStore,
	markAsShippedViewStore: { form, onSwitch, loading, isLtlOrder },
}) => {
	if (loading) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				{isLtlOrder ? (
					<LtlOrderElements markAsShippedViewStore={markAsShippedViewStore} />
				) : (
					<React.Fragment>
						<ButtonGroup className="k-button-group--fullwidth spc--bottom--sml">
							<Button
								type="button"
								className="btn btn--sml"
								togglable={true}
								selected={form.$('isInternal').value}
								onClick={onSwitch}
								disabled={form.submitting}
							>
								{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.INTERNALSHIPMENT')}
							</Button>
							<Button
								type="button"
								className="btn btn--sml"
								togglable={true}
								selected={!form.$('isInternal').value}
								onClick={onSwitch}
								disabled={form.submitting}
							>
								{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.EXTERNALSHIPMENT')}
							</Button>
						</ButtonGroup>
						{form.$('isInternal').value && <NonLtlOrderElements markAsShippedViewStore={markAsShippedViewStore} />}
					</React.Fragment>
				)}

				{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--bottom--sml"
					type="submit"
					disabled={
						form.submitting ||
						(isLtlOrder && !markAsShippedViewStore.selectedItem.assignedWarehouseId)
					}
					label="SAVE"
				/>
			</div>
		</form>
	);
};

const NonLtlOrderElements = observer(
	({ markAsShippedViewStore: { form, onKeyUp, warehouseDropdownStore, carrierServiceDropdownStore, selectedItem, isSuperAdminOrganization } }) => {
		return (
			<div className="inputgroup">
				<BaasicInput field={form.$('trackingNumber')} onKeyUp={e => onKeyUp(e, form.$('trackingNumber'))} />
				<BaasicInput field={form.$('cost')} onKeyUp={e => onKeyUp(e, form.$('cost'))} />				

				{(selectedItem.seller.sellerOrganizationInfo.showSurplusCharge === true || isSuperAdminOrganization) &&  (
					<BaasicInput
						field={form.$('shippingCostSurcharge')}
						onKeyUp={e => onKeyUp(e, form.$('shippingCostSurcharge'))}
					/>
				)}
				

				<div className="spc--bottom--sml">
					<BaasicDropdown dropdownStore={warehouseDropdownStore} />
				</div>
				<div className="spc--bottom--sml">
					<BaasicDropdown dropdownStore={carrierServiceDropdownStore} />
				</div>
			</div>
		);
	}
);

const LtlOrderElements = observer(({ markAsShippedViewStore: { form, onKeyUp, carrierDropdownStore } }) => {
	return (
		<div className="inputgroup">
			<BaasicInput field={form.$('trackingNumber')} onKeyUp={e => onKeyUp(e, form.$('trackingNumber'))} />
			<div className="spc--bottom--sml">
				<BaasicDropdown dropdownStore={carrierDropdownStore} />
			</div>
		</div>
	);
});

export default defaultTemplate(MarkAsShippedTemplate);
